import React, {useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUser, faBars, faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import {faGithub, faInstagram, faLinkedin, faMedium, faStackOverflow, faTwitter,} from "@fortawesome/free-brands-svg-icons";
import {useNavigate, Link as RouterLink} from "react-router-dom"
import {HashLink} from "react-router-hash-link"
import { Box, Text,HStack, VStack, Center, Image, Link, Switch,useBreakpointValue,IconButton, Button, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerCloseButton, DrawerBody, transition, background} from "@chakra-ui/react";
import {IconButton as IconB, Button as BButton} from "@mui/material";
import logo from "../Assets/logo.png" 
import benLogo from "../Assets/Ben-Asenso-logo-white.png"
import benLogoBlack from "../Assets/Ben-Asenso-logo-black.png"
import { assets } from "../AssetsPort/assets";
import XIcon from "@mui/icons-material/X"
import ArrowOutwardSharpIcon from "@mui/icons-material/ArrowOutwardSharp"
import ModeNightRoundedIcon from '@mui/icons-material/ModeNightRounded';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';



const socials = [
  {
    icon: faEnvelope,
    url: "mailto: asenso95@gmail.com",
    name: "Mail"
  },
  {
    icon: faGithub,
    url: "https://www.github.com/asenso95",
    name: "Github"
  },
  {
    icon: faLinkedin,
    url: "https://www.linkedin.com/in/benasenso",
    name:"LinkedIn"
  },
  {
    icon: faMedium,
    url: "https://www.medium.com/benasenso",
    name: "Medium"
  },
  {
    icon: faStackOverflow,
    url: "https://www.stackoverflow.com/benasenso",
    name: "StackOverflow"
  },
  
  // {
  //   icon: faTwitter,
  //   url: "https://www.twitter.com/ararat-ben",
  //   name: "Twitter"
  // },

  
];


function Header ({toggleProp, setToggle, selected, setSelected}){
  
let navigate = useNavigate()


//Creating Scrollable view to Projects-Section
function eventHandler(){
  let element = document.getElementById("projects-section")
  if (element){
    element.scrollIntoView({
      behavior: "smooth",
      block: "start"
    })
  }
  else{
    return;
  }
} 

let [scrollDown, setScrollDown] = useState(false)

useEffect((e)=>{
  let func = ()=>{
    if (window.scrollY>50){
      setScrollDown(true)
    }else{
      setScrollDown(false)
    }
  }
  window.addEventListener("scroll", func) 
  return()=>{
    window.removeEventListener("scroll",func)
  }

}, [])

 //Creating visibility of the menu depending on Scroll
 let [scrollUp, setscrollUp] = useState(true) 
 let [prevScroll, setprevScroll] = useState(0)

 useEffect((e) => {
  let  handleScroll=() => {
  let verticalScroll = window.scrollY

  setscrollUp(verticalScroll < prevScroll) // This is comparing the previous scroll with the current scroll ie verticalScroll
  setprevScroll(verticalScroll) //this now update the prevSroll(0) with the vertical scroll position number & the comparison continues 
}

  window.addEventListener("scroll", handleScroll)
//Remove Event listener to save Memory when the component is unmounted/Or no longer rendered in the current view/Or user navigates away from page
//The return is a cleanup function for all your cleanup activities in useEffect
return () => {
  window.removeEventListener("scroll", handleScroll)
}
 }, [ prevScroll]) 



 //Creating a Hamburger Menu / base represents mobile & md represents desktop
 let mobileView = useBreakpointValue({
  base: true,
  lg: false
 })


 let tabletView = useBreakpointValue({
  md: true,
  lg:false  
 })

  let nextHub = useBreakpointValue({
   lg:true,
   xl:false
 })

 let Hstyle = {

  position: "fixed",
  //background: "#18181b",
  color: "black",
  padding: mobileView? "5px 10px": "10px 20px 10px 20px",
  right:"0",
  left:"0",
  top: "0",
  transition: "top 0.3s ease-in-out",
  zIndex: 100,
  //backgroundImage: "linear-gradient(180deg, rgba(0,0,0,0.7) 10%, transparent)"
  //backgroundImage: assets.header_bg_color

 }



 let [isOpen, setIsOpen] = useState(false)

 let onClose = ()=>{
  return setIsOpen(false)
 }

 
 if (mobileView) {
  return (
    <div>

    {scrollUp &&
    <div style={{...Hstyle, height: "var(--header-height)"}}   className={`shadow-sm ${(scrollDown&&scrollUp)&&"border-b-[0.5px]"} border-white/50 ${toggleProp? "bg-[#11001f] bg-opacity-100":"bg-white bg-opacity-50"}  ${scrollDown? "backdrop-blur-lg shadow-sm":""}`} >

    {/* Creating Overlay */}
    <div className="translate-y-[-80%]" style = {{
      //background: "rgba(0, 0, 0, 0.4)",
      //background: "linear-gradient(to bottom, #FFD2D7,rgba(0, 0, 0, 0.7) 20%)",
      display:"none",
      position: "fixed",
      top: "0%",  /*mobileView="1%" */
      //bottom: 0,
      //left: 0,
      //right:"0%",
      width: "100%",
      //height: "10%",
      zIndex: -1,
      pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
    }}>    

    <Image src={assets.header_bg_color} />
    </div>

    
    <HStack  spacing={tabletView? 10:8} paddingLeft={tabletView? 4: 1} paddingRight={tabletView? 4: 1} color="white" right="0" >
      {/* <Box>
        <Image src={toggleProp? assets.logo_dark:assets.logo} className="w-28 cursor-pointer mr-14" />
      </Box>  */}

      <Box>
        <Image src={benLogo} style={{filter:!toggleProp? "invert(100%)":""}} alt="Ben Asenso logo" title="Ben Asenso Web Developer and Digital Marketing Freelancer" width={200} /> 
      </Box>

      <HStack marginLeft="auto" spacing={8}>
       {/* <HStack spacing={4} >           
          <FontAwesomeIcon size="xl" icon={toggleProp? faSun: faMoon}/>
          <div >
          <Switch size="lg" isChecked={toggleProp} onChange={(e)=> setToggle(!toggleProp)}  />
          </div>
      </HStack> */}

      {/* <button onClick={(e)=> setToggle(!toggleProp)}>
        <img src={toggleProp? assets.sun_icon:assets.moon_icon} alt="" className="w-6" />
      </button> */}

      <IconB onClick={(e)=> setToggle(!toggleProp)} >
        {toggleProp? <WbSunnyRoundedIcon color="primary" aria-label="Theme toggle button"/> : <ModeNightRoundedIcon  />}
      </IconB>

      <IconButton as={IconB}  onClick={(e)=>{  //icon= {<FontAwesomeIcon icon={faBars} size="xl"  />}
      setIsOpen(true)
      }}>
        <img src={assets.menu_black} className="w-6"/>
      </IconButton>
  
    </HStack>
    
       
      
    </HStack> 
    
  

    <Drawer 
    isOpen={isOpen}
    onClose={onClose}
    size={ tabletView && "md"}
     >
      <DrawerOverlay>
        <DrawerContent maxH="100vh">
         <DrawerCloseButton color={toggleProp? "white": "black"} size="lg" />
          
         <DrawerHeader bg={toggleProp && "#11001f"} color= "#EDEFEE">
          {/*  <Image src={logo} maxWidth="20vw"  /> */}
            <Link href="https://benasenso.com">
            <Image src={benLogo} style={{filter:!toggleProp? "invert(100%)":""}} alt="Ben Asenso logo" title="Ben Asenso Web Developer and Digital Marketing Freelancer" boxSize="250px" height={14}  /> 
            </Link>
            
          </DrawerHeader>

          <DrawerBody color={toggleProp && "white"} bg={toggleProp? "#11001f": "linear-gradient(to top, #fda4af, white)"} pt={tabletView && 10}>
            <VStack>
            <Button variant="ghost" transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Home"? "#2a4365" : "", color: selected == "Home"? "white" :""}} onClick={(e)=> {
               
               navigate("/")
               setSelected("Home")

               setTimeout((e) => {
                 let element = document.getElementById("home")
                 if (element){
                   element.scrollIntoView({
                     behaviour: "smooth"
                   })
                   setTimeout(() => {
                    onClose()
                   }, 1000);
                 }
               },5);
            }}>Home</Button>    
              
            <Button variant="ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "About"? "#2a4365" : "", color: selected == "About"? "white" :""}} onClick={(e)=> {
               
               navigate("/")
               setSelected("About")

               setTimeout((e) => {
                 let element = document.getElementById("About")
                 if (element){
                   element.scrollIntoView({
                     behaviour: "smooth"
                   })
                   setTimeout(() => {
                    onClose()
                   }, 1000);
                 }
               },5);
            }}>About Me</Button>

            <Button variant= "ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Projects"? "#2a4365" : "", color: selected == "Projects"? "white" :""}} onClick={(e)=> {

              navigate("/")
              setSelected("Projects")

              setTimeout((e) => {
                let element = document.getElementById("projects")
                if (element){
                  element.scrollIntoView({
                    behaviour: "smooth"
                  })
                  setTimeout(() => {
                    onClose()
                   }, 1000);
                }
              },5);
            }}>Projects</Button>
           
           <Button variant= "ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Services"? "#2a4365" : "", color: selected == "Services"? "white" :""}} onClick={(e)=>{
              
              navigate("/")
              setSelected("Services")

              setTimeout((e) => {
                let element = document.getElementById("services")
                if (element){
                  element.scrollIntoView({
                    behaviour: "smooth"
                  })
                  setTimeout(() => {
                    onClose()
                   }, 1000);
                }
              },5);
            }}>Services</Button>
            
            <Button variant= "ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Skills"? "#2a4365" : "", color: selected == "Skills"? "white" :""}} onClick={(e)=>{
              
              navigate("/")
              setSelected("Skills")

              setTimeout((e) => {
                let element = document.getElementById("skills")
                if (element){
                  element.scrollIntoView({
                    behaviour: "smooth"
                  })
                  setTimeout(() => {
                    onClose()
                   }, 1000);
                }
              },5);

            }}>Experience</Button>

            <Button as={RouterLink} to="/blog" variant= "ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Blog"? "#2a4365" : "", color: selected == "Blog"? "white" :""}} onClick={(e)=> {
              setSelected("Blog")
              onClose()
              }} > 
              Blog
            </Button> 
            
            <Button variant= "ghost" mt={tabletView && 8} transform= {tabletView? "scale(1.8)": "scale(1.2)"} size="lg" color={toggleProp && "white"}  style={{ background: selected == "Contact" ? "#2a4365" : "", color: selected == "Contact"? "white" :""}} onClick={(e)=>{
            
              navigate("/")
              setSelected("Contact")
              
              setTimeout((e) => {
                let element = document.getElementById("contact")
                if (element){
                  element.scrollIntoView({
                    behaviour: "smooth"
                  })
                  setTimeout(() => {
                    onClose()
                   }, 1000);
                }
              },5);
            }}         
            >Contact Me</Button>
    

            

           
            <HStack spacing={8}  mt={20}>
            <Link href="https://www.stackoverflow.com/benasenso" isExternal _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} mt="40">
            <FontAwesomeIcon icon={faStackOverflow} size="2xl" />
            </Link>
            <Link href="https://www.x.com/Ararat_Ben" isExternal _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} mt="40">
            <XIcon  style={{fontSize:28}} />
            </Link>
            <Link href="https://www.Instagram.com/bengizzlettl" isExternal _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} mt="40">
            <FontAwesomeIcon icon={faInstagram} size="2xl" />
            </Link>
            <Link href="https://www.medium.com/benasenso" isExternal _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} mt="40" >
            <FontAwesomeIcon icon={faMedium} size="2xl" />
            </Link>
            
           
            </HStack>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
    </div> }

    </div>
  )
 }

 else {
  return(
    <div>
      {scrollUp &&
      <>
      {/* <div className="fixed top-0 right-0  -z-100 translate-y-[-80%]"> /*w-11/12
        <Image src={assets.header_bg_color} alt="" className="w-full"/>
      </div>       */} 

      {/* Creating Overlay */}
      <div className="translate-y-[-93%]" style = {{
        //background: "linear-gradient(to bottom, #FFD2D7,rgba(0, 0, 0, 0.7) 20%)",
        display:"none",
        position: "fixed",
        top: "0%",  
        //bottom: 0,
        //left: 0,
        right:"0%",
        width: "100%",
        zIndex: 10,
        pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
      }}>    

      <Image src={assets.header_bg_color} />
      </div>

  
      <HStack spacing={8} style={{...Hstyle, height: "var(--header-height)"}} className={`shadow-sm ${(scrollDown&&scrollUp)&&"border-b-[0.5px]"} border-white/50 ${toggleProp? "bg-[#11001f] bg-opacity-100":"bg-white bg-opacity-50"}  ${scrollDown? "backdrop-blur-lg shadow-sm":""}`}  >
      
      {/* <Box>
        <Image src={toggleProp? assets.logo_dark:assets.logo} className="w-28 cursor-pointer mr-14" />
      </Box>  */}
      
      <Box as={RouterLink} to="/">
        <Image src={benLogo} style={{filter:!toggleProp? "invert(100%)":""}} alt="Ben Asenso logo" title="Ben Asenso Web Developer and Digital Marketing Freelancer" width={200} /> 
      </Box>


      <Box m="0 auto" className={`${nextHub? "px-6":"px-12"} rounded-full ${scrollDown? "":`bg-white bg-opacity-50 shadow-sm ${toggleProp&& "border border-white/50 bg-transparent"}`} `}>
      <HStack spacing={4} alignSelf="right" color={toggleProp? "white":""}>  {/*Spacing used to be {8} before material-ui */}

      {/* <HStack spacing={4}>
           
        <FontAwesomeIcon size="xl" icon={toggleProp? faSun: faMoon}/>
         <div >
         <Switch size="lg" isChecked={toggleProp} onChange={(e)=> setToggle(!toggleProp)}  />
         </div>
      </HStack> */}


      {/* <Link as={HashLink} smooth to="/#home" _hover={{fontWeight: "bold", textDecoration: "underline"}} >
      Home
      </Link> */}
      <div  style={{position:"relative"}}>
      <HashLink smooth to="/#home"  >
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}><span className="font-semibold">Home</span></BButton>
      </HashLink>

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="Home")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>
      
      <div style={{position:"relative"}}>
      <HashLink smooth to="/#about"  >
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}><span className="font-semibold">About Me</span></BButton>
      </HashLink>

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="About")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>

      <div style={{position:"relative"}}>
      <Link as={HashLink} smooth to="/#services" > 
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}> <span className="font-semibold">Services</span></BButton>
      </Link>

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="Services")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>

      <div style={{position:"relative"}}>
      <Link as={HashLink} smooth to="/#projects"  >
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}><span className="font-semibold">Projects</span></BButton>
      </Link>

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="Projects")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>

    
      {/* <Link as={HashLink} smooth to="/#skills" >
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}}}><span className="font-semibold">Experience</span></BButton>
      </Link> */}

      <div style={{position:"relative"}}>
      <Link as={RouterLink} to="blog" >
      <BButton color="inherit" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}><span className="font-semibold">Blog</span></BButton>
      </Link> 

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="Blog")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>


      <div style={{position:"relative"}}>
      <Link as={HashLink} smooth to="/#contact"   >
      <BButton color="inherit" size="large" sx={{textTransform:"none", '&:hover':{color:""}, position:"relative", zIndex:10}}><span className="font-semibold">Contact Me</span></BButton>      
      </Link>

        <div style={{position:"relative"}}></div>
        <div style={{position:"absolute", bottom:"0%", left:"20%", zIndex:0, display:(toggleProp&&selected==="Contact")? "block":"none", pointerEvents:"none"}}>
        <img src={assets.nav_underline} />      
        </div>
      </div>

     
      </HStack>
      </Box>

      {/* <div className="flex items-center gap-4">
        <button onClick={(e)=> setToggle(!toggleProp)}>
          <img src={toggleProp? assets.sun_icon: assets.moon_icon} alt="" className="w-6" />
        </button>
        <a href="#contact" className={`hidden lg:flex items-center gap-3 px-10 py-2.5 border ${toggleProp? "border-white/50":"border-black"} rounded-full ml-4 ${toggleProp? "text-white":""}`}>
         Contact <img src={toggleProp? assets.arrow_icon_dark:assets.arrow_icon} alt="" className="w-3" />
        </a> 
      </div>   */}

      <IconB onClick={(e)=> setToggle(!toggleProp)} >
        {toggleProp? <WbSunnyRoundedIcon color="primary" aria-label="Theme toggle button"/> : <ModeNightRoundedIcon  />}
      </IconB>

      {!nextHub &&<Box mt={-2}>
      <HashLink to="#contact">
      <BButton variant="contained" endIcon={<ArrowOutwardSharpIcon style={{fontSize:24}} />} sx={{px:4, borderRadius:"50px", color:toggleProp?"white":"#374151", textTransform:"none", background:toggleProp? "linear-gradient(267deg, #DA7C25 0.36%, #B923E1 102.06%)":"transparent", border:toggleProp? "1px solid white":"1px solid #374151", mt:1, '&:hover':{background:toggleProp? "linear-gradient(167deg, #DA7C25 0.36%, #B923E1 102.06%)":"#fcf4ff"} }} ><span style={{fontWeight:"bold", padding:4}} >Contact</span></BButton>
      </HashLink>
      </Box> }
      

      </HStack>
      </> }
    
  </div>
  )
 }

} 
  
export default Header 
 